<template>
   <div class="wrap course-content">
    <div class="header">
      <div class="detail-header">
      <div class="header-top">
        <img src="../../images/ico_next_l@2x.png" @click="backLastPage" style="cursor: pointer" />
        <h3 class="title">笔记详情</h3>
      </div>
      <div class="toVideo" v-if="!note.is_video_delete" @click="goVideo()">前往视频</div>
      </div>
    </div>
    <div class="course-content">
      <div class="content">
      <div v-html="note.content"></div>
      <div class="nodeContainer" v-for="(item,index) in note.node_mark" :key="index" @click="goVideo(item, 1)">
          <img src="../../images/note-sign.png" alt="">
          <span class="time">{{item.time}}</span>
          <span class="videoNodeTitle">{{item.title}}</span>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
       note:{}
    }
  },
  props:{
    detail:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  created(){
    this.getDetail()
  },
  methods:{
    goVideo(item, index){
      if (index != 1) {
        this.$router.push({
        path:`/yueke3/${this.note.course_id}/${this.note.class_id}`,
        query:{
          view_time:this.detail.view_time,video_id:this.detail.video_id,chapter_id:this.detail.chapter_id,sectionId:this.detail.section_id,name:this.detail.name,duration:this.detail.duration,file_id:this.detail.file_id
        }})
      } else {
        this.$router.push({
        path:`/yueke3/${this.note.course_id}/${this.note.class_id}`,
        query:{
          view_time:this.detail.view_time,video_id:this.detail.video_id,chapter_id:this.detail.chapter_id,sectionId:this.detail.section_id,name:this.detail.name,duration:this.detail.duration,file_id:this.detail.file_id,zhuanbj: 1,memory: item.memory
        }})
      }
    },
    backLastPage(){
      this.$emit('changePage',{page:'NoteList'})
    },
    async getDetail(){
      const data={
         chapter_id:this.detail.chapter_id,
         video_id:this.detail.video_id
      }
      const res=await this.$axios.post('/stu/course/getNoteDetail',data)
      console.log('[<-- res-Detail -->]',res);
      this.note=res.data.data
    }
  },
}
</script>

<style lang="scss" scoped> 
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  min-height: 880px;
  .header{
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    height: 64px;
    box-sizing: border-box;
    .detail-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .toVideo{
        width: 90px;
        height: 32px;
        background: linear-gradient(107deg,#73aaff 0%, #0053ff 100%);
        border-radius: 6px;
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        text-align: center;
        line-height: 32px;
      }
    }
    .header-top{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .title {
        font-size: 20px;
        font-weight: 400;
        color: #20242f;
      }
    }
  }
  .nodeContainer{
  width:fit-content;
  height: 20px;
  background: #f1f2f7;
  border-radius: 40px;
  padding: 7px 16px;
  font-size: 14px;
  font-weight: 400;
  color: #202020;
  display: flex;
  align-items: center;
  justify-content: start;
  margin-top: 10px;
  img{
    height: 16px !important;
    width: 16px !important;
    margin-right: 6px;
  }
  .time{
    margin-right: 10px;
  }
  .videoNodeTitle{
    display: inline-block;
    white-space:nowrap;
  }
}
  .content{
    width: 100%;
    word-break: break-word;
    margin-top: 10px;
  }
}
</style>